import React, { Suspense } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom'; // 1. Importar useLocation
import { Container } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import '../../../assets/style/scss/state-machine.scss';
import { injectIntl } from 'react-intl';
import routes from '../../../routes';
import LoadingModal from '../../components/Commons/LoadingModal';

const Footer = React.lazy(() => import('./Footer'));
const Header = React.lazy(() => import('./Header'));

const Layout = () => {
    const location = useLocation(); // 2. Obtener la ubicación directamente del hook
    const pathname = location?.pathname || '';

    if (pathname === '/header' || window.location.hash === '#/header') {
        return (
            <CustomComponent className="header">
                <Header />
            </CustomComponent>
        );
    } else if (pathname === '/footer' || window.location.hash === '#/footer') {
        return (
            <CustomComponent className="footer">
                <Footer />
            </CustomComponent>
        );
    }

    return (
        <div className="app">
            <div className="header">
                <Container disableGutters maxWidth={false}>
                    <Suspense fallback={<CircularProgress />}>
                        <Header />
                    </Suspense>
                </Container>
            </div>
            <div className="body">
                <main>
                    <Container disableGutters maxWidth={false}>
                        <Suspense fallback={<LoadingModal loading={true} />}>
                            <Switch>
                                {routes.map((route, idx) => {
                                    if (route.component) {
                                        return (
                                            <Route
                                                key={idx}
                                                path={route.path}
                                                name={route.name}
                                                exact={route.exact}
                                                render={(routeProps) => (
                                                    <route.component {...routeProps} />
                                                )}
                                            />
                                        );
                                    }
                                    return null;
                                })}
                            </Switch>
                        </Suspense>
                    </Container>
                </main>
            </div>
            <div className="footer">
                <Container disableGutters maxWidth={false}>
                    <Suspense fallback={<CircularProgress />}>
                        <Footer />
                    </Suspense>
                </Container>
            </div>
        </div>
    );
};

export default injectIntl(Layout);

const CustomComponent = ({ className, children }) => {
    return (
        <div className="app">
            <div className={className}>
                <Container disableGutters maxWidth={false}>
                    <Suspense fallback={<CircularProgress />}>
                        {children}
                    </Suspense>
                </Container>
            </div>
        </div>
    );
};